'use client';

import { useEffect } from 'react';
import { useTheme } from 'next-themes';

export type CatalogThemeMode = 'user' | 'light' | 'dark';

export function CatalogThemeForcer({ mode }: { mode: CatalogThemeMode }) {
  const { setTheme } = useTheme();

  useEffect(() => {
    if (mode === 'light' || mode === 'dark') {
      setTheme(mode);
    }
  }, [mode, setTheme]);

  return null;
}
